<header class="lg:grid lg:grid-cols-6 lg:items-center">
  <a
    class="flex items-center justify-center w-6 h-6 text-3xl mb-3 -ml-2 lg:m-0"
    [routerLink]="backLink.path"
    [queryParams]="backLink.queryParams"
    [attr.aria-label]="backLinkAriaLabel"
  >
    <vtmn-play-icon [name]="iconType.ArrowLeft"></vtmn-play-icon>
  </a>

  <div class="flex items-baseline lg:col-span-5">
    <h1 class="title-4">
      {{ title }}
    </h1>

    <ng-content></ng-content>
  </div>
</header>
